import { render, staticRenderFns } from "./OrganizationEditTabSocial.vue?vue&type=template&id=43f5a3f6"
import script from "./OrganizationEditTabSocial.vue?vue&type=script&lang=js"
export * from "./OrganizationEditTabSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports